'use strict';

var icon = {};

exports.__exports = icon;
//# sourceMappingURL=icon4.cjs.map
